import CreditCardIcon from '@mui/icons-material/CreditCard';

import type { DashboardCustomerPaymentMethod } from '@models/customers';
import { getPaymentMethodBrand, type PaymentMethodBrand } from '@features/customers/helpers';

import { MastercardBadgeIcon } from '@assets/customers/icons/mastercard-badge-icon';
import { VisaBadgeIcon } from '@assets/customers/icons/visa-badge-icon';
import { ApplePayIcon } from '@assets/payments/icons/apple-pay-icon';
import { GooglePayIcon } from '@assets/payments/icons/google-pay-icon';
import { PaypalIcon } from '@assets/payments/icons/paypal-icon';
import s from './CustomerDetailPanel.module.css';

const BRAND_BADGE_CLASSES: Record<PaymentMethodBrand, string> = {
  visa: 'brandVisa',
  mastercard: 'brandMastercard',
  paypal: 'brandPaypal',
  googlepay: 'brandGooglepay',
  applepay: 'brandApplepay',
  card: 'brandCard',
};

type PaymentMethodBrandBadgeProps = {
  method: DashboardCustomerPaymentMethod;
};

function PaymentMethodBrandBadge({ method }: PaymentMethodBrandBadgeProps) {
  const brand = getPaymentMethodBrand(method);
  return (
    <span className={`${s.brandBadge} ${s[BRAND_BADGE_CLASSES[brand]]}`}>
      {brand === 'visa' && <VisaBadgeIcon />}
      {brand === 'mastercard' && <MastercardBadgeIcon />}
      {brand === 'paypal' && <PaypalIcon />}
      {brand === 'googlepay' && <GooglePayIcon />}
      {brand === 'applepay' && <ApplePayIcon />}
      {brand === 'card' && <CreditCardIcon sx={{ fontSize: 18 }} />}
    </span>
  );
}

export default PaymentMethodBrandBadge;
